import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { WebAccessControlSchedulerBaseDataProvider } from '../dataProvider/WebAccessControlSchedulerBaseDataProvider';
import { WebAccessControlSchedulerDataProviderFactory } from '../factory/WebAccessControlSchedulerDataProviderFactory';
import { AssignScheduleToPoliciesResponse, GetPoliciesByScheduleIdResponse, ScheduleItem, SchedulesResponse } from '../types';

export class WebAccessControlSchedulerRepository extends BaseWebComponentRepository {
  public dataProviderFactory: WebAccessControlSchedulerDataProviderFactory;
  public dataProvider: WebAccessControlSchedulerBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new WebAccessControlSchedulerDataProviderFactory(),
    });
  }

  public async getDataForView() {
    return this.dataProvider.getDataForView();
  }

  public async removeRecords(records: Array<ScheduleItem>): Promise<SchedulesResponse> {
    return this.dataProvider.removeRecords(records);
  }

  public async getPoliciesByWebAccessControlScheduleId(companyId: string, scheduleId: string): Promise<GetPoliciesByScheduleIdResponse> {
    return this.dataProvider.getPoliciesByWebAccessControlScheduleId(companyId, scheduleId);
  }

  public async assignScheduleToPolicies(companyId: string, scheduleId: string, policyIds: string[]): Promise<AssignScheduleToPoliciesResponse> {
    return this.dataProvider.assignScheduleToPolicies(companyId, scheduleId, policyIds);
  }
}
